import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation Users($user: CreateUserInput!, $avatar: Upload) {
  createUser(user: $user, avatar: $avatar) {
    user {
    id
    role
    operatorTeamId
    overseerTeams {
      id,
      name
    }
    name
    email
    fullName
    firstName
    lastName
    displayName
    middleName
    absenceReason
    avgVote
    logged
    ready
    ucceInfo {
      uccePeripheralId
      uccePeripheralFirstName
      uccePeripheralLastName
      uccePeripheralLogin
    }
    useExpress
    ctsUserId
    external
    }
    avatarUpload
  }
}`;

const fieldsName = {
  name: 'T_LOGIN',
  email: 'T_EMAIL',
  role: 'T_ROLE',
  password: 'T_ENTER_PASSWORD',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function createUser({
  name,
  email,
  firstName,
  lastName,
  middleName,
  displayName,
  role,
  operatorTeamId,
  overseerTeamsIds,
  password,
  uccePeripheralId,
  uccePeripheralFirstName,
  uccePeripheralLastName,
  uccePeripheralLogin,
  avatar,
  external,
}) {
  return apollo.client.mutate({
    mutation,
    variables: {
      user: {
        name,
        email,
        firstName,
        lastName,
        middleName,
        displayName,
        role,
        operatorTeamId,
        overseerTeamsIds,
        password,
        uccePeripheralId,
        uccePeripheralFirstName,
        uccePeripheralLastName,
        uccePeripheralLogin,
        external,
      },
      avatar,
    },
  }).then((res) => res.data.createUser)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default createUser;
